<template lang="pug">
.mt-5.mb-2.d-flex.flex-column.align-items-start
  //- .tooltips.me-2
  //-   i.fa.fa-info-circle 
  //-   span.tooltipstext Green indicates active number, Red indicates inactive number
  .text-uppercase {{$t('ui.accounts')}} : 
    span.text-activeacc.ms-2.fw-bold {{activeCount}}
    span.text-inactiveacc.fw-bold ({{inactiveCount}}) 
    span / {{totalCount}} 
  div
    .box-activeacc
    .d-inline.align-middle &nbsp;&nbsp;: {{$t('ui.active')}}
  div
    .box-inactiveacc 
    .d-inline.align-middle &nbsp;&nbsp;: {{$t('ui.inactive')}} 
</template>
<script>
export default {
  props: {
    displayType:{
      type: String,
      default: ""
    }
    // activeCount: {
    //   type: Number,
    //   default: 0
    // },
    // inactiveCount:{
    //   type: Number,
    //   default: 0
    // },
    // totalCount:{
    //   type: Number,
    //   default: 0
    // },
  },
  data(){
    return{
      activeCount: "",
      inactiveCount: "",
      totalCount: ""
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  created(){
    this.getActiveList()
  },
  methods:{
    getActiveList(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/activeList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							// response.data.forEach(y => {
              //   if(y.category==='BANK'){
              //     this.bActivelist.push(y)
              //   }else if(y.category === 'EWALLET'){
              //     this.eActivelist.push(y)
              //   }
                
              // })
              response.data.filter(x => x.category === this.displayType).forEach(y => {
                this.activeCount = y.active
                this.inactiveCount = y.inactive
                this.totalCount = y.total

              })
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    }
  }
}
</script>